<section>
  <h1 class="date-header">
    {{ viewDate | calendarDate
    : view + 'ViewTitle'
    : locale
    : weekStartsOn
    : excludeDays
    }}
  </h1>
  <div class="group-navigation">
    <div class="btn-group">
      <div
        class="btn btn-primary btn-back"
        mwlCalendarPreviousView
        [view]="view"
        [(viewDate)]="viewDate"
        (click)="addNewEvents(true, false)">
        <
      </div>
      <div
        class="btn btn-outline-secondary"
        mwlCalendarToday
        [(viewDate)]="viewDate"
        (click)="addNewEvents(false, false)">
        Hoje
      </div>
      <div
        class="btn btn-primary btn-next"
        mwlCalendarNextView
        [view]="view"
        [(viewDate)]="viewDate"
        (click)="addNewEvents(false, true)">
        >
      </div>
    </div>
    @if (showStatusSubtitle) {
      <div>
        <span><b>Legenda: </b></span>
        <span><span class="color-dot" [style.background-color]="'#C5C5C5'"></span> Horários Antigos | </span>
        <span><span class="color-dot" [style.background-color]="'#626AC2'"></span> Consulta Finalizada | </span>
        <span><span class="color-dot" [style.background-color]="'#85C443'"></span> Agendado</span>
      </div>
    }
    @if (canChangeView) {
      <div class="btn-group">
        <div
          class="btn btn-primary"
          (click)="setView(CalendarView.Month)"
          [class.active]="view === CalendarView.Month">
          Mês
        </div>
        <div
          class="btn btn-primary"
          (click)="setView(CalendarView.Week)"
          [class.active]="view === CalendarView.Week">
          Semana
        </div>
        <div
          class="btn btn-primary"
          (click)="setView(CalendarView.Day)"
          [class.active]="view === CalendarView.Day">
          Dia
        </div>
      </div>
    }
  </div>
</section>
<br>
<div>
  @switch (view) {
    @case (CalendarView.Month) {
      <mwl-calendar-month-view
        [viewDate]="viewDate"
        [events]="events"
        [locale]="locale"
        [weekStartsOn]="weekStartsOn"
        [excludeDays]="excludeDays"
        [weekendDays]="weekendDays"
        [refresh]="refresh"
        [activeDayIsOpen]="activeDayIsOpen"
        [tooltipTemplate]="tooltipTemplate"
        [tooltipAppendToBody]="false"
        (eventClicked)="eventClicked($event.event)"
        (dayClicked)="dayClicked($event.day)"
        >
      </mwl-calendar-month-view>
    }
    @case (CalendarView.Week) {
      <mwl-calendar-week-view
        [viewDate]="viewDate"
        [events]="events"
        [locale]="locale"
        [weekStartsOn]="weekStartsOn"
        [excludeDays]="excludeDays"
        [weekendDays]="weekendDays"
        [hourSegments]="hourSegments"
        [dayStartHour]="dayStartHour"
        [dayEndHour]="dayEndHour"
        [refresh]="refresh"
        [tooltipTemplate]="tooltipTemplate"
        [tooltipAppendToBody]="false"
        (eventClicked)="eventClicked($event.event)"
        >
      </mwl-calendar-week-view>
    }
    @case (CalendarView.Day) {
      <mwl-calendar-day-view
        [viewDate]="viewDate"
        [events]="events"
        [locale]="locale"
        [hourSegments]="hourSegments"
        [dayStartHour]="dayStartHour"
        [dayEndHour]="dayEndHour"
        [refresh]="refresh"
        [tooltipTemplate]="tooltipTemplate"
        [tooltipAppendToBody]="false"
        (eventClicked)="eventClicked($event.event)"
        >
      </mwl-calendar-day-view>
    }
  }
</div>

<ng-template #tooltipTemplate let-event="event">
  <div class="cal-tooltip cal-tooltip-top">
    <div class="cal-tooltip-arrow"></div>
    <div class="cal-tooltip-inner">{{event.title}}, {{event.meta?.description}}, {{event.start | date:'dd/MM/yyyy - HH:mm:ss'}}
      <br>
        {{event.meta?.status ? 'Status: ' + event.meta.status : ''}}
      </div>
    </div>
  </ng-template>
